module.exports = __webpack_public_path__ + "img/triceratops.13783b91.jpg";